// extracted by mini-css-extract-plugin
export default {"tabHeading":"FormsAndReport_tabHeading__pz5u4","includeCheckBox":"FormsAndReport_includeCheckBox__ZT1KW","exportIcon":"FormsAndReport_exportIcon__5JRkn"};